import React, { useContext, useState } from "react";
import { useAttributeFormBuilder, useLayout } from "../../../../Hooks/Display/useComponentProperties";
import SectionActions from "./SectionActions";
import { useTranslation } from "react-i18next";
import { usePropsStoreValue } from "../../../../Hooks/PropStore/usePropsStore";
import GenericTranslationDialog from "../../../Entities/GenericTranslationDialog";
import { GlobalContext } from "../../../../Renderers/GlobalContext";

const SectionHeader = ({ sectionId }) => {

    const { t } = useTranslation([
        "display/components/form"
    ]);

    const { subscription } = useContext(GlobalContext).state

    const [{ steps }, dispatch] = useAttributeFormBuilder();
    const layout = useLayout();
    const project = usePropsStoreValue("project");
    const [showLabelTranslationDialog, setShowLabelTranslationDialog] = useState(false);
    const currentSection = layout.find((section) => section.id === sectionId);

    const handleSectionName = (e) => {
        dispatch.updateSectionName(e.target.value, sectionId);
    };

    const setLabelTranslation = (data) => {
        dispatch.updateSectionLanguages(data, sectionId);
        setShowLabelTranslationDialog(false);
    }

    const isSectionNameExists = () => {
        const sectionCount = layout.filter((section) => section.section === currentSection.section).length;
        return sectionCount > 1;
    };

    return (
        <div className="d-flex justify-content-between p-3">
            <div className="form-group row w-50">
                <label className="col-2 col-form-label">
                    {t("section.section_name", { ns: "display/components/form" })}
                </label>
                <div className="col-9">
                    <input
                        type="text"
                        className={`form-control${isSectionNameExists() ? ' border-danger' : ''}`}
                        value={currentSection.section}
                        placeholder={t("section.section_name_placeholder", { ns: "display/components/form" })}
                        onChange={handleSectionName}
                    />
                </div>
                {showLabelTranslationDialog && (
                    <GenericTranslationDialog
                        onClose={() => { setShowLabelTranslationDialog(false) }}
                        onSave={setLabelTranslation}
                        languages={currentSection.languages}
                        project={project}
                        fields={["section"]}
                        type={t("section.section_name", { ns: "display/components/form" })}
                    />
                )}
                {subscription.numOfLanguages > 1 &&
                    <div className="col-1">
                        <buttton
                            onClick={() => setShowLabelTranslationDialog(true)}
                            className="btn btn-secondary">
                            <i className="fas fa-language"></i>
                        </buttton>
                    </div>
                }
            </div>
            <SectionActions sectionId={sectionId} />
        </div>
    );
};

export default SectionHeader;
